function getRoutes({ schema, ProtectedRoute, BubbleRouteError, Pages }) {
  if (!schema || !Array.isArray(schema)) {
    return [];
  }

  const routes = schema.map(route => {
    const {
      path,
      children = null,
      crumb = null,
      icon = null,
      permissionName = null,
      element,
    } = route;
    return {
      path,
      ...(element && { element: Pages[element] || null }),
      errorElement: <BubbleRouteError />,
      handle: { crumb, icon, permissionName },
      ...(children && {
        children: getRoutes({
          schema: children,
          ProtectedRoute,
          BubbleRouteError,
          Pages,
        }),
      }),
    };
  });
  return routes;
}

export default getRoutes;
